import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7de0616"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "relative flex justify-center h-full w-full text-white",
  id: "bg-custom"
}
const _hoisted_2 = { class: "flex flex-col space-y-8 backdrop-blur-3xl p-8 w-full h-full overflow-x-auto" }
const _hoisted_3 = { class: "flex flex-col space-y-4 md:flex-row" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "flex flex-col space-y-8 md:pt-8" }
const _hoisted_6 = { class: "absolute bottom-8 right-8 left-8 flex flex-col space-y-8" }
const _hoisted_7 = { class: "flex flex-row space-x-4 mx-auto" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-row space-x-4"
}
const _hoisted_9 = {
  key: 1,
  class: "flex flex-row space-x-4"
}

import { computed, ref } from "vue";
import BigTitle from "@/components/Title/BigTitle.vue";
import MediumTitle from "@/components/Title/MediumTitle.vue";
import { useRouter } from "vue-router";
import SliderOval from "@/components/Slider/SliderOval.vue";
import SliderRound from "@/components/Slider/SliderRound.vue";
import SmallText from "@/components/Texts/SmallText.vue";
import PrimaryButton from "@/components/Form/Common/PrimaryButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const router = useRouter();

const gradientStyle = computed(() => {
  return `linear-gradient(to right, #4338ca, #9333ea}) 1`;
});

const currentSlide = ref(0);
const slides: {
  title: string;
  text: string;
  img: string;
}[] = [
  {
    title: "Drinkolow",
    text: "Bienvenue sur l'application ultime de Drinkolow! Transformez vos soirées avec une expérience de picole personnalisée.",
    img: "slider1.png",
  },
  {
    title: "Personnalisation des Joueurs",
    text: "Adaptez votre expérience de jeu en modifiant les joueurs en cours de partie. Ajoutez et supprimez les joueurs pour une soirée encore plus mémorable.",
    img: "slider2.png",
  },
  {
    title: "Choix de Catégories",
    text: "Explorez une variété infinie de catégories pour pimenter le jeu. Des questions amusantes aux défis créatifs, personnalisez votre picolo selon vos préférences.",
    img: "slider3.png",
  },
  {
    title: "Nombre de Gorgées Personnalisé",
    text: "Décidez ensemble du niveau d'intensité de la fête en définissant le nombre de gorgées par action. De 1 à 15 gorgées par actions, laissez les joueurs guider l'ambiance.",
    img: "slider4.png",
  },
  {
    title: "Gestion des Timers",
    text: "Chaque action compte! Gérez facilement les timers pour les actions spécifiques. Visualisez, recommencez, arrêtez, mettez en pause - le contrôle est entre vos mains.",
    img: "slider5.png",
  },
  {
    title: " Menu d'Aide Intégré",
    text: "Besoin d'un coup de main? Consultez notre menu d'aide intégré pour des instructions rapides et des astuces. Plus de confusion, juste du plaisir!",
    img: "slider6.png",
  },
  {
    title: "Nombre de Tours",
    text: "Contrôlez la durée de votre soirée en ajustant le nombre de tours. Une partie rapide entre amis ou une nuit épique, c'est à vous de décider.",
    img: "slider7.png",
  },
  {
    title: "Commencer Maintenant",
    text: "Commencez dès maintenant à créer des souvenirs inoubliables! C'est le moment de rire, de trinquer et de profiter de l'aventure!",
    img: "slider8.png",
  },
];

const changeSlide = (index: number) => {
  currentSlide.value = index;
};

const redirectToRouteGame = () => {
  router.push("game");
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: "border h-screen border-8 box-border",
    style: _normalizeStyle({ borderImage: gradientStyle.value })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(BigTitle, {
          title: "Drinkolow",
          class: "text-left"
        }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: 'img/slider/' + slides[currentSlide.value].img,
            alt: slides[currentSlide.value].img,
            class: "md:w-1/3 mb-4 md:mr-4"
          }, null, 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(MediumTitle, {
              title: slides[currentSlide.value].title
            }, null, 8, ["title"]),
            _createVNode(SmallText, {
              text: slides[currentSlide.value].text
            }, null, 8, ["text"]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(slides, (slide, index) => {
                  return _createElementVNode("div", { key: index }, [
                    (index === currentSlide.value)
                      ? (_openBlock(), _createBlock(SliderOval, { key: 0 }))
                      : (_openBlock(), _createBlock(SliderRound, {
                          key: 1,
                          onClick: ($event: any) => (changeSlide(index))
                        }, null, 8, ["onClick"]))
                  ])
                }), 64))
              ]),
              (currentSlide.value !== slides.length - 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_router_link, {
                      to: "/game",
                      class: "text-white md:text-lg text-md px-2 py-1 rounded-lg cursor-pointer border w-1/2 text-center"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Passer ")
                      ]),
                      _: 1
                    }),
                    _createVNode(PrimaryButton, {
                      label: "Prochain",
                      class: "w-1/2",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (changeSlide(currentSlide.value + 1)))
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_router_link, {
                      to: "/game",
                      class: "w-full text-white md:text-lg text-md px-2 py-1 rounded-lg bg-gradient-to-r from-purple-600 to-indigo-700 cursor-pointer text-center"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Jouer ")
                      ]),
                      _: 1
                    })
                  ]))
            ])
          ])
        ])
      ])
    ])
  ], 4))
}
}

})